import type { AllRouteEndpoints } from "../routeTypes";
export const companiesCompanyIdSecuritySettingsSecurityEventConfigTestCacheKeys: AllRouteEndpoints[] = [];
